import { PropsWithChildren } from 'react';
import { HeroUIProvider } from '@heroui/react';

type ThemeProviderProps = {
  theme?: 'dark' | 'light';
} & PropsWithChildren;

const ThemeProvider = ({ theme = 'light', children }: ThemeProviderProps) => {
  return (
    <HeroUIProvider validationBehavior="aria">
      <main className={theme}>{children}</main>
    </HeroUIProvider>
  );
};

export default ThemeProvider;
